<template>
  <div class="container bg-white">
    <div class="ent-name" v-if="entAccountObj">
      {{ entAccountObj.accountName }}
    </div>
    <div class="container-flex">
      <pi-balance-block
        :accountObj="entAccountObj ? entAccountObj : accountDetailAll"
        btnName="充值记录"
        @btnClick="gotoRecord"
      ></pi-balance-block>
      <div class="recharge-right-now">当前账户</div>
      <div class="recharge-phone" v-if="entAccountObj">
        {{ entAccountObj.accountPkId }}
      </div>
      <div class="recharge-phone" v-else>{{ userInfo.phoneNo }}</div>
      <div class="recharge-money-tip">充值金额</div>
      <div class="recharge-money-tips">
        <div
          v-for="(item, index) in moneyArr"
          :key="index"
          @click="select(item)"
          class="recharge-tips recharge-tips-top"
          :class="money == item ? 'active' : ''"
        >
          ¥{{ item }}
        </div>
      </div>
      <div class="recharge-money-need">
        <div class="recharge-money-unit">¥</div>
        <input
          class="recharge-money-input echarge-money-unit"
          @input="moneyChange"
          type="number"
          placeholder="请输入您要充值的金额"
          v-model="money"
          maxlength="4"
          @blur="moneyBlur"
          @focus="moneyFocus"
        />
      </div>
    </div>
    <div>
      <div class="recharge-aggree">
        点击立即充值即表示您已阅读并同意
        <router-link class="agree-color" to="/recharge/protocol"
          >《充值协议》</router-link
        >
      </div>
      <div class="recharge-button">
        <pi-button block type="primary" @click="recharge">立即充值</pi-button>
      </div>
    </div>
  </div>
</template>

<script>
import balanceBlock from "@/components/pi-balance-block/pi-balance-block.vue";
import {
  queryPayResult,
  makePayOrder,
  makePayOrderXl,
  // getAccount,
  getUserAccount,
  getUserBaseInfo,
  getEntAccount,
  getOprCongifInfo,
  ccbPayOrder,
} from "../../common/api";
/* global WeixinJSBridge */
let toast = null;
export default {
  name: "change-money",
  components: {
    [balanceBlock.name]: balanceBlock,
  },
  data() {
    return {
      accountPkId: "",
      accountDetailAll: {},
      userInfo: {},
      money: "30",
      accountType: "",
      entAccountObj: null, // 企业账户
      moneyArr: [10, 30, 50, 100, 200, 500],
      minRechargeAmount: 0.01, // 最小充值金额
      oprInfo: {},
      readyFormData: null,
      isPay: false,
      balanceAmount: 0,
    };
  },

  mounted() {
    this.userType = this.$common.query("userType") || 1;
    if (this.userType == "3") {
      this.getEntAccount();
    } else {
      this.getUserBaseInfo();
      this.getUserAccount();
    }
  },
  methods: {
    /**
     * 充值记录
     */
    gotoRecord() {
      this.$router.push({
        name: "record",
        query: {
          accountPkId: this.userType == "3" ? this.accountPkId : '',
          orderType: 0,
        },
      });
    },
    /**
     * 获取运营商配置信息
     */
    async getOprCongifInfo() {
      let ret = await getOprCongifInfo({});
      if (ret.status === this.$config.ajaxStatus && ret.data.length > 0) {
        this.oprInfo = ret.data[0];
      }
    },
    /**
     * 获取企业账户信息
     */
    async getEntAccount() {
      this.loading = true;
      let ret = await getEntAccount({});
      if (ret.status === this.$config.ajaxStatus && ret.data.length > 0) {
        var data = ret.data[0];

        this.accountPkId = data.accountPkId;
        this.entAccountObj = data;
        this.accountType = data.accountType;
        this.balanceAmount = data.balanceAmount;
        // 企业充值选项
        if (data.minRechargeAmount > 0) {
          this.minRechargeAmount = data.minRechargeAmount;
          if (data.minRechargeAmount > 10) {
            let min = data.minRechargeAmount;
            let moneyArr = [];
            for (let i = 0; i < 6; i++) {
              if (i == 0) {
                moneyArr.push(min);
              } else {
                min = min + 100;
                moneyArr.push(min);
              }
            }
            this.moneyArr = moneyArr;
            this.selectMoney = moneyArr[0];
            this.money = moneyArr[0];
          }
        }
      }
      this.loading = false;
    },
    /**
     * 获取用户信息，就用一个手机号码
     */
    async getUserBaseInfo() {
      const ret = await getUserBaseInfo({});
      if (ret.status === 0) {
        let data = ret.data[0] || {};
        this.userInfo = data;
      }
    },
    /**
     * 获取个人账户信息
     */
    async getUserAccount() {
      let that = this;
      this.loading = true;
      let ret = await getUserAccount({});
      if (ret.status === that.$config.ajaxStatus && ret.data.length > 0) {
        var data = ret.data[0];
        this.accountDetailAll = data;
        this.accountType = data.accountType;
        this.accountPkId = data.accountPkId;
        this.balanceAmount = data.balanceAmount;
      }
      this.loading = false;
    },
    /**
     * 输入框输入内容验证
     */
    moneyChange() {
      let val = this.money + "";
      if (val) {
        this.money = /^\d+\.?\d{0,2}$/.test(val)
          ? this.money
          : val.slice(0, val.length - 1);
      }
    },
    /**
     * 失去焦点，用在软键盘可能挡住的问题
     */
    moneyBlur() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
    },
    /**
     * 取焦用在软键盘可能挡住的问题
     */
    moneyFocus() {
      setTimeout(() => {
        window.scrollTo(0, this.winHeight);
      }, 500);
    },
    /**
     * 选择金额
     */
    select(item) {
      this.selectMoney = item;
      this.money = item;
    },
    /**
     * 充值点击
     */
    async recharge() {
      if (this.minRechargeAmount && this.money < this.minRechargeAmount) {
        this.$toast("充值金额不能小于" + this.minRechargeAmount);
        return;
      } else if (this.money < 0.01) {
        this.$toast("充值金额不能小于0.01");
        return;
      }
      let getPay;
      let data = {
        accountPkId: this.accountPkId,
        accountType: this.accountType,
        rechargeAmount: this.money,
        appType: 1,
      };
      if (this.oprInfo.wxPayMethod == 2) {
        getPay = makePayOrderXl;
        data.appType = 6;
      } else if (this.oprInfo.wxPayMethod == 3) {
        // 天津建行支付
        data.appType = 9;
        getPay = ccbPayOrder;
      } else {
        getPay = makePayOrder;
      }
      getPay(data)
        .then((data) => {
          console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            this.order = data.data[0];
            if (typeof WeixinJSBridge === "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady();
            }
          } else {
            this.$toast(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    queryPayResult() {
      queryPayResult({
        rechargeOrderNo: this.order.rechargeOrderNo,
      })
        .then((data) => {
          console.log(data);
          // alert(JSON.stringify(data));
          if (data.status === this.$config.ajaxStatus) {
            if (data.data.length > 0 && data.data[0].orderStatus === 6) {
              toast.clear();
              //支付成功
              let currentMoney = data.data[0].afterBalance;
              this.$dialog
                .alert({
                  title: "充值成功",
                  message: "当前余额" + currentMoney,
                  confirmButtonText: "关闭",
                  confirmButtonColor: "#999999",
                  closeOnPopstate: true,
                })
                .then(() => {
                  // on confirm
                  this.$router.go(-1);
                })
                .catch(() => {
                  // on cancel
                });
            } else {
              throw new Error();
            }
          } else {
            throw new Error();
          }
        })
        .catch((error) => {
          console.log(error);
          this.queryCount--;
          if (this.queryCount <= 0) {
            this.queryCount = 0;
            // this.$toast('充值成功，还没有收到到账通知，请稍后刷新查看余额！');
            toast.clear();
            this.$dialog
              .alert({
                title: "提示",
                message: "充值成功，还没有收到到账通知，请稍后刷新查看余额",
                confirmButtonText: "关闭",
                confirmButtonColor: "#999999",
                closeOnPopstate: true,
              })
              .then(() => {
                // on confirm
              })
              .catch(() => {
                // on cancel
              });
          } else {
            setTimeout(() => {
              this.queryPayResult();
            }, 3000);
          }
        });
    },
    /**
     * 微信内H5调起支付
     * https://pay.weixin.qq.com/wiki/doc/api/jsapi.php?chapter=7_7&index=6
     */
    onBridgeReady() {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: this.order.appId,
          timeStamp: this.order.timeStamp,
          nonceStr: this.order.nonceStr,
          package: this.order.package,
          signType: this.order.signType,
          paySign: this.order.paySign,
        },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            console.log("pay success");
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            toast = this.$toast.loading({
              duration: 0,
              forbidClick: true,
              message: "请稍后...",
            });
            this.queryCount = 10;
            this.queryPayResult();
          } else {
            console.log("pay error");
            this.$dialog
              .alert({
                title: "充值失败",
                confirmButtonText: "关闭",
                confirmButtonColor: "#999999",
                closeOnPopstate: true,
              })
              .then(() => {
                // on confirm
                this.$router.go(-1);
              })
              .catch(() => {
                // on cancel
              });
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.container-flex {
  position: relative;
  padding: 0.2rem;
}

.recharge-right-now {
  height: 0.48rem;
  font-size: 0.34rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.48rem;
  margin-top: 0.2rem;
}

.recharge-phone {
  font-size: 0.34rem;
  font-weight: 500;
  color: #333333;
  line-height: 0.48rem;
  margin-top: 0.2rem;
  border-bottom: 0.01rem solid #eeeeee;
}

.recharge-money-tip {
  height: 0.48rem;
  font-size: 0.34rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.48rem;
  margin-top: 0.3rem;
  padding-left: 0.05rem;
}

.recharge-money-tips {
  height: 1.92rem;
  margin-top: 0.2rem;
  font-size: 0.4rem;
  line-height: 0.48rem;
  color: #333;
}

.recharge-tips {
  float: left;
  width: 2.16rem;
  height: 0.8rem;
  background: #fafafa;
  border-radius: 0.16rem;
  text-align: center;
  margin-right: 0.24rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wen {
  width: 0.34rem;
  height: 0.34rem;
  vertical-align: text-bottom;
  margin-left: 0.05rem;
}
.recharge-tips:active,
.active {
  background: rgba(20, 204, 128, 0.13);
  border-color: #14cc80;

  color: #14cc80;
}

.recharge-tips-top {
  margin-bottom: 0.24rem;
}

.recharge-tips:nth-child(3n) {
  margin-right: 0rem;
}

.recharge-money-need {
  margin-top: 0.3rem;
  border-bottom: 0.01rem solid #eeeeee;
  position: relative;
}

.recharge-money-unit {
  height: 0.48rem;
  font-size: 0.4rem;
  font-weight: 500;
  color: #333333;
  line-height: 0.48rem;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: bold;
}

.recharge-money-input {
  width: 100%;
  height: 0.48rem;
  font-size: 0.4rem;
  font-weight: bold;
  color: #333;
  line-height: 0.48rem;
  padding-left: 0.3rem;
  box-sizing: border-box;
}

.recharge-aggree {
  margin-top: 0.4rem;
  height: 0.38rem;
  font-size: 0.18rem;
  color: #999999;
  line-height: 0.38rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.recharge-button {
  padding: 0.3rem 0.4rem;
}

.recharge-refund {
  margin-top: 0.2rem;
  height: 0.33rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #14cc80;
  line-height: 0.33rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
}

.agree-color {
  color: #0e94fb;
}
.ent-name {
  background: rgba(255, 210, 152, 0.25);
  color: #666;
  font-size: 0.24rem;
  line-height: 0.33rem;
  height: 0.33rem;
  padding: 0.08rem;
  text-align: center;
  width: 100%;
}
</style>
